import React, { useEffect, useRef, useState } from "react";
import Layout from "../components/Layout";

const TermsAndConditions = () => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("100%");

  useEffect(() => {
    const handleResize = (event) => {
      if (event.data) {
        setIframeHeight(`${event.data}px`);
      }
    };

    window.addEventListener("message", handleResize);
    return () => {
      window.removeEventListener("message", handleResize);
    };
  }, []);
  return (
    <Layout>
      <div className="privacy_policy">
        <div className="container">
          <h1 className="text-center">Terms and Conditions</h1>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 32,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                Terms &amp; Conditions
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                1. Introduction
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              1.1 To use the Service, Users must Accept these Terms, which
              should be read carefully prior to using the Service. These Terms
              represent a binding contract between AZZIR and the User. If the
              User does not wish to be bound by these Terms, the User should not
              Accept these Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              PLEASE NOTE THAT CLAUSE 10 OF THESE TERMS INCLUDES AN EXCLUSION OF
              WARRANTIES AND LIMITATION OF LIABILITY.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                2. Definitions
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.1 In these Terms the following definitions shall apply, unless
              the context otherwise requires:
            </span>
          </p>
          <table
            style={{
              border: "none",
              background: "transparent",
              borderCollapse: "collapse",
            }}
          >
            <tbody>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Accept
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means either:
                      <br />
                      &nbsp;(i) to register to use the Service by means of the
                      registration screen; or
                      <br />
                      &nbsp;(ii)to use the Service;
                      <br />
                      &nbsp;and thereby to agree to be bound by these Terms;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      App
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means any mobile application developed and made available
                      to the public by AZZIR, through which Users can receive
                      the Service;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Content
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means information, software, photographs, video, graphics,
                      music, sound and other material that appears on the
                      Website or are made available through the Service;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Customer
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means any User who uses the Service to make purchases,
                      registrations or donations from or to an Event or who
                      purchases a Voucher for an Offer;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Data Controller
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      has the meaning set out in the Data Protection Laws;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Data Processor
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      has the meaning set out in the Data Protection Laws;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Data Protection Laws
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the Data Protection Act 1998 as amended, updated and
                      re-enacted from time to time, the EC Directive on the
                      protection of individuals with regard to the Processing of
                      personal data and on the free movement of such data
                      (95/46/EC), the General Data Protection Regulation
                      (Regulation (EU) 2016/679) and all local laws or
                      regulations giving effect to the Directive and Regulation
                      (as any such legislation, directive or regulation may be
                      amended, extended or re-enacted);
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Data Subject
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      has the meaning set out in the Data Protection Laws;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Direct Pay
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the direct pay method of payment, as set out in
                      clause 5.2.11;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Event
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means any event for which a User can purchase or register
                      for a Ticket, or for which a User can advertise or sell
                      Tickets, as part of the Service;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      AZZIR
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means Azzir Events LLP, a company registered in Mumbai,
                      India whose registered office is at 7th Floor, Esperanca,
                      Shahid Bhagat Singh Road <br /> Near Electric House,
                      Colaba, <br /> Mumbai Maharashtra 400001
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      GDPR
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the General Data Protection Regulation (EU)
                      2016/679;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Intellectual Property Rights
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means throughout the world all copyrights, database
                      rights, trade marks, trade names, patents and other
                      intellectual property or industrial property rights
                      created, developed and subsisting;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Normal Pay
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the normal pay method of payment, as set out in
                      clause 6.4;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Offer
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means an item a Promoter can list via the Website and/or
                      App that has a given validity period, during which a
                      Customer can exchange a pre-paid Voucher for goods or
                      services. Offer is alternatively referred to as voucher.
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Partner
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means a User who uses the Service to promote and sell
                      Tickets for the Events of other Promoters, and who can
                      appoint other Reps to sell on their behalf, in exchange
                      for which the Promoter pays a commission to the Partner;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Password
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      has the meaning given to it in clause 5.1.7;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      PDPs
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means potentially destructive contaminating or harmful
                      programs or components such as, but not limited to, worms,
                      trojan horses and viruses;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Personal Data
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      has the meaning set out in the Data Protection Laws;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Promoter
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      any User who uses the Service to promote and sell Tickets
                      for its own Events or Offers;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Rep
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means a User who uses the Service to promote and sell
                      Tickets for the Events of other Promoters, but who cannot
                      appoint other Reps to sell on their behalf, in exchange
                      for which the Promoter pays a commission to the Rep;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Reseller
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means a User who uses the Service to recommend and
                      introduce other Promoters to AZZIR, in exchange for which
                      AZZIR pays a commission to the Reseller;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Server
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the server used by AZZIR to host the Website;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Service
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the entertainment, advertisements, Facebook
                      applications, Ticket sales and information provided by
                      AZZIR by means of the Website and/or SMS;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      SMS
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means short message service;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Ticket
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means an item purchased via the Website or App that gains
                      the user entry into a specified Event;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      these Terms
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the terms and conditions of this Agreement;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      User
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the individual, business (including any sole trader,
                      partnership, limited company or other organisation or
                      person) that has registered (either themselves or by means
                      of a duly authorised officer, agent or other
                      representative) with AZZIR by means of the registration
                      screen on the Website or any App or that uses the Service,
                      including Promoters, Resellers, Partners, Reps and
                      Customers;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      User's Equipment
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the User's own computer equipment,
                      telecommunications dial-up connection, software, any
                      telecommunication services and communications lines
                      (including any public lines) required by the User properly
                      to access and use the Service;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Voucher
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means an item purchased via the Website or App that
                      permits the user to exchange it for goods or services,
                      outlined by a listed Offer;
                    </span>
                  </p>
                </td>
              </tr>
              <tr>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                        color: "black",
                      }}
                    >
                      Website
                    </span>
                  </p>
                </td>
                <td style={{ padding: ".75pt .75pt .75pt .75pt" }}>
                  <p
                    style={{
                      marginTop: "0cm",
                      marginRight: "0cm",
                      marginBottom: ".0001pt",
                      marginLeft: "0cm",
                      lineHeight: "normal",
                      fontSize: 15,
                      fontFamily: '"Calibri",sans-serif',
                    }}
                  >
                    <span
                      style={{
                        fontSize: 14,
                        fontFamily: '"Segoe UI",sans-serif',
                      }}
                    >
                      means the website with URL{" "}
                      <u>
                        <span style={{ color: "#5E72E4" }}>
                          <a target="_blank" href="https://azzirevents.com/">
                            <span style={{ color: "#5E72E4" }}>AZZIR</span>
                          </a>
                        </span>
                      </u>{" "}
                      or such other URL or URLs as AZZIR may in its sole
                      discretion from time to time decide by means of which
                      AZZIR may provide the Service;
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                2.2 Unless the context otherwise requires:
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.2.1 reference to any statute or statutory provision includes a
              reference to: that statute or statutory provision as from time to
              time amended, extended, re-enacted or consolidated; and all
              statutory instruments or orders made pursuant to it;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.2.3 words denoting any gender shall denote all genders and words
              denoting persons shall include firms and corporations and vice
              versa;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.2.4 reference to any clause or sub-clause is to a clause or
              sub-clause (as the case may be) of these Terms;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.2.5 the headings in these Terms are inserted for convenience
              only and shall not affect the construction or interpretation of
              these Terms; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              2.2.6 any words following the terms including, include, in
              particular, for example or any similar expression shall be
              construed as illustrative and shall not limit the sense of the
              words, description, definition, phrase or term preceding those
              terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                3. COMMENCEMENT OF AGREEMENT
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              The contract between AZZIR and the User shall be effective from
              the time that the User first Accepts these Terms and shall remain
              in force until or unless terminated under these Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                4. TERMS APPLICABLE
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              4.1 In consideration for AZZIR providing all or part of the
              Service the User agrees to be bound by these Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              4.2 AZZIR may vary these Terms at any time. Such variations shall
              become effective immediately upon the posting of the modified
              Terms on the Website or the App or notification to the User. By
              continuing to use the Service following any such variation, the
              User shall be deemed to accept such variation.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5. USE OF THE SERVICE
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5.1 Use of the service by the User
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.1 For the duration of these Terms, AZZIR grants to the User a
              personal, non-exclusive, non-transferable, non-sublicensable,
              revocable, limited right to use the Service for the purpose of
              being a Customer, a Reseller, a Partner, a Promoter and/or a Rep.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.2 The User shall be responsible for obtaining and maintaining
              the User’s Equipment. AZZIR has no responsibility or liability for
              the User’s Equipment.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.3 The User represents and warrants that it or a suitably
              qualified employee, agent or sub-contractor, has familiarised
              itself with relevant laws, licences, codes of practice,
              guidelines, directives and regulations relating to the subject
              matter of this agreement. The User shall ensure at all times that
              their use of any part of the Service, including connection of the
              User’s Equipment to the Server, is in accordance with all
              applicable data protection and other laws, licences, codes of
              practice and regulations in force from time to time.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.4 The Service shall only be used by the User or a duly
              authorised officer, agent or other representative of the User. The
              User may not assign, novate, re-sell, sub-license, charge or
              otherwise deal with either the whole or part of the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.5 The User shall not (and shall not permit any third party to)
              copy, adapt, reverse engineer, decompile, disassemble, modify,
              adapt or make error corrections to the Website, the App or the
              Service in whole or in part.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.6 The User shall not (and shall not permit anyone else to)
              publish, copy, store, modify, transmit, distribute or broadcast
              any part of the Content except where it is necessary to do so to
              enable the User to receive the Service in accordance with these
              Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.7 In order to access the Service, the User may be required to
              use a unique password (“Password”). The User may only disclose
              their Password to their duly authorised officers, agents or other
              representatives. The User is responsible for the security and
              proper use of their Password and shall take all necessary steps to
              ensure that the Password is kept confidential, used properly and
              not disclosed to unauthorised persons.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.8 The User shall immediately notify AZZIR if they have reason
              to believe that:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.8.1 the Password is no longer confidential;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.8.2 has been an unauthorised use of the Password or the
              User’s Service account; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.8.3 there has been any other breach of security relating to
              the Password, the Website, the App or the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.9 AZZIR at its sole discretion reserves the right to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.9.1 refuse to accept a User’s registration;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.9.2 limit a User’s access to the whole or any part of the
              Service at any time; and/or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 5.1.9.3 cancel, suspend or withdraw a User’s access to the whole
              or any part of the Service at any time.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.10 Access to the Website is permitted on a temporary basis and
              AZZIR reserves the right to suspend at its sole discretion the
              whole or any part of the Service for any reason whatsoever. In
              such situations, AZZIR shall seek to, but shall not be obliged to,
              give the User as much notice as is reasonably practicable. For the
              avoidance of doubt, AZZIR shall not be liable to the User for any
              loss whatsoever arising from such a suspension.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.11 AZZIR shall be entitled to vary the technical specification
              of the Service and/or the Website and/or the App from time to
              time. AZZIR may, for this purpose, suspend access to the Service
              and/or the Website and/or the App or close any one or more of them
              indefinitely.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.12 Any of the material on the Website and/or the App
              (including the Content) may be out of date at any given time and
              AZZIR is under no obligation to update such material or Content.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.1.13 AZZIR shall be entitled to close any User accounts which
              are inactive for a period of 6 (six) months or more, including
              Customer, Reseller, Partner, Rep and/or Promoter accounts. If, at
              the time it is closed, such User account is in credit by any
              amount, AZZIR will keep a record of the account for 3 (three)
              months after it is closed, during which period the User shall be
              entitled to request that AZZIR reactivate their account or
              withdraw any amounts by which the account is in credit. If, at the
              end of the 3 (three) month period, the User has not reactivated
              their account or withdrawn the funds in their account, they shall
              be deemed to have waived absolutely their right to collect such
              amount and AZZIR shall be entitled to retain such amount for its
              own personal account.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5.2 Use of the Service by Promoters
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.1 AZZIR is a self-serve platform which allows Promoters to
              market and promote Events and Offers.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.2 AZZIR is in no way responsible for the content of Events or
              Offers uploaded onto the Service and in no way endorses nor is
              affiliated with these Events or Offers.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.3 AZZIR is in no way responsible for the use of the Service by
              any Customers, Resellers, Partners or Reps and as such is not
              liable to the Promoter for any act or omission of such Resellers,
              Partners, Customers or Reps.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.4 The Promoter listing the Event and/or Offer shall be solely
              responsible for ensuring that the Event and/or Offer details are
              correct, including: entry times, Ticket price, Event/Offer
              details, Voucher price, Reseller fees, Partner fees, Rep fees,
              booking fee variations and door policy. AZZIR is in no way
              responsible for incorrectly entered details for such Events or
              Offers, nor is it responsible for any revenue lost as a
              consequence.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.5 A Promoter may import their own database into the Server in
              order for AZZIR to promote a Promoter’s Event to its existing
              customers. Where this occurs, the provisions of clause 11.4.1
              shall apply.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.6 Where the Promoter imports their databased pursuant to
              clause 5.2.5, and where the individuals within the database are
              not registered with AZZIR, AZZIR agrees that it shall only promote
              the Promoter’s Events to the individuals within the Promoter’s
              database.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.7 Promoters may co-promote an Event with another Promoter.
              Where this occurs, AZZIR agrees that it shall only send marketing
              materials or information in relation to the Event on behalf of
              each Promoter to their respective Customers/followers (for
              example, previous customers of promoter 1 will receive news of the
              Event on behalf of promoter 1, with previous customers of promoter
              2 receiving news of the Event on behalf of promoter 2).
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.8 Should the Promoter cancel an Event or withdraw an Offer, it
              is the Promoter’s responsibility to inform AZZIR and the Users who
              purchased Tickets and Vouchers. In such circumstance, the Promoter
              shall refund all Ticket and Vouchers sales in accordance with
              these Terms and is responsible for processing refunds using the
              Service, or contacting Users regarding an alternative date or
              substitute Offer.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.9 AZZIR has the right to remove any Event or Offer and to
              remove from sale any Tickets or Vouchers which it in its absolute
              discretion deems to be unsuitable for the AZZIR platform.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.10 The Promoter shall allow AZZIR to act as a Ticket agent for
              its Events and Offers. AZZIR has a right to charge a booking fee
              to the Customer over and above the face value of the Ticket or
              Offer. This fee constitutes a financial transaction charge used to
              cover AZZIR’s cost of taking the transaction.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.11 Promoters selling Tickets or Vouchers through their own
              merchant account with AZZIR (Direct Pay) are liable to pay all
              booking fees, Partner fees and Rep fees to AZZIR within 30 days of
              the invoice being issued.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.12 AZZIR reserves the right to transfer the Promoter back onto
              the Normal Pay method at its absolute discretion. Furthermore,
              AZZIR may take any outstanding fees due from a Promoter’s future
              Ticket sales.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.13 AZZIR reserves the right to not allow the Promoter to use
              the Direct Pay method of payment.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.14 The User hereby acknowledges and agrees:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.14.1 that AZZIR may receive a request to release information
              in relation to a particular Event or Offers and the identity of
              the User offering such Events and Offers to regulatory bodies
              including, without limitation, the advertising standards authority
              and the information commissioner’s office (Regulatory Bodies) and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.14.2 that AZZIR may release such information to the Regulatory
              Bodies.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.15 AZZIR’s Deductibles: Along with reconciliation reports,
              AZZIR shall raise an invoice on Event Organizer for (a) the
              charges specified in the Main Terms including the Commission; (b)
              reimbursements that AZZIR is entitled to in terms of this
              Agreement including, refunds to Customers, chargebacks on
              debit/credit cards etc.; (c) any other costs or amounts payable by
              Event Organizer, as may be mutually agreed between the Parties in
              writing (emails permitted); and (d) GST, TDS and TCS (if
              applicable). AZZIR shall be entitled to deduct, and retain the
              above-said deductibles from the gross sales value of Tickets sold
              before releasing the applicable Net Revenue. The Parties agree
              that all amounts specified herein that become due and payable
              shall be exclusive of applicable taxes. All payments under this
              Agreement shall be paid in Indian Rupees together with such GST or
              equivalent as may be payable thereon without any deduction,
              withholding or set-off unless the same is required by law.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.2.16 Each Party shall be liable to pay all applicable taxes in
              respect of the income it earns in accordance with applicable laws.
              In case either Party is under an obligation to deduct tax at
              source and/or any levy/tax, the deducting Party shall issue a
              requisite certificate to the other Party evidencing such deduction
              of tax.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5.3 Use of the Service by Partners and Reps
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.1 AZZIR provides a platform to Partners and Reps to enable
              them to promote Tickets for Events in return for a commission,
              which is set and paid by the Promoter.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.2 The Partner shall be entitled to appoint its own Reps to
              promote Tickets for Events on behalf of itself, in return for a
              commission which is set and paid by the Partner.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.3 AZZIR is in no way responsible for commissions set by
              Promoters or Partners and is not affiliated with the Events or
              Offers in any way.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.4 AZZIR shall not be liable to pay any agreed commission to
              the Partners or Reps. A Rep’s sole remedy for non-payment of such
              commission shall be against either the Promoter or the Partner
              (whichever it is acting on behalf of) and the Partner’s sole
              remedy for non-payment of such commission shall be against the
              Promoter.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.5 Partners and Reps are neither employed by the Promoters nor
              by AZZIR directly. It is the Partner’s and Rep’s sole
              responsibility to declare and be accountable for any taxation
              requirements. AZZIR is acting purely as a platform for Partners
              and Reps to earn commission from Promoters.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.6 Each Partner and Rep is responsible for the withdrawal of
              their funds from their User account with AZZIR, as well as
              providing AZZIR with correct bank details.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.7 Partners and Reps shall at all times act in good faith
              towards both AZZIR and the Promoter and shall not act in any
              manner which might bring either AZZIR or the Promoter into
              disrepute.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.3.8 Each Partner and each Rep shall ensure that, when promoting
              and marketing any Tickets to Events, they do not misrepresent any
              details about the Event and that all information they provide
              about the Event is accurate and not misleading.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5.4 Use of the Service by Resellers
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.4.1 AZZIR provides a platform to Resellers to enable them to
              introduce Promoters to AZZIR, in return for a commission of a
              percentage of all booking fees which AZZIR receives relating to
              the Promoter’s Events, such percentage shall be as notified and
              varied by AZZIR to the Reseller from time to time.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.4.2 The Reseller shall be able to introduce Promoters to AZZIR
              by the provision of a unique Reseller link or via an email sent
              using the Service. The Reseller shall only be deemed to be a
              Reseller of the Promoter if the Promoter signs up through one of
              the two methods set out in this clause 5.4.2.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.4.3 AZZIR shall ensure that all sums due to the Reseller
              relating to an Event are available to be withdrawn by the Reseller
              three (3) days after the end of the Event.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                5.5 Use of the Service by Customers
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.5.1 AZZIR provides a platform to Customers to enable them to
              search for, purchase and register for Tickets/Vouchers for Events
              and Offers, which are promoted and advertised on the Service by
              Promoters.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.5.2 AZZIR is in no way responsible for the description, staging,
              quality or value of Events or Offers and is not affiliated with
              the Events or Offers in any way.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.5.3 AZZIR shall not be liable to the Customer for any refunds –
              please see clause 6 for details as to payment and refunds.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.5.4 The Customer shall comply with any applicable terms and
              conditions of the Promoter, the venue of an Event, the Offer or
              any other relevant party.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              5.5.5 Customers shall be entitled to browse and ‘follow’ various
              Promoters from time to time through the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                6. PAYMENT
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.1 Tickets are sold through either the Normal Pay method or the
              Direct Pay method, depending on which method has been adopted by
              the Promoter of such Event.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.2 Vouchers are sold through either the Normal Pay method or the
              Direct Pay method, depending on which method has been adopted by
              the Promoter of such Offer.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.3 The operation of the two payment methods shall be as set out
              in this clause 6.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                6.4 Normal pay Ticket and Voucher sales
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.1 Tickets and Vouchers sold through AZZIR’s Normal Pay method
              are sold for Events and Offers advertised by Promoters, where
              transactions are processed through AZZIR’s own online merchant and
              bank account. Transactions of this nature adhere to the terms of
              clause 6.4.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.2 AZZIR shall ensure that all sums due to the Promoter
              relating to an Event are available to be withdrawn by the Promoter
              after three (3) days from the end of the Event.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.3 AZZIR shall ensure that all sums due to the Promoter
              relating to an Offer are available to be withdrawn by the Promoter
              within fourteen (14) days of the end-date of the Offer, as set by
              the Promoter.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.4 A Customer shall be entitled to cancel a Voucher that they
              have purchased and receive a full refund of the price from the
              Promoter at any time up to fourteen (14) days after the date of
              purchase, unless the Voucher has already been redeemed, in which
              case the Customer will be deemed to have lost their right of
              cancellation at the point of redemption.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.5 A Customer may apply for a refund of the price of the Ticket
              prior to the Event in question, provided that Tickets for the
              Event remain on sale. Acceptance of refunds are determined by the
              Event’s refund policy, which is set by the Promoter, and it is the
              Customer’s responsibility to check this policy with the Promoter
              prior to purchasing the Ticket. AZZIR shall not be liable to the
              Customer for any refunds.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.6 If the Promoter agrees to provide the Customer with a refund
              in accordance with clauses 6.4.4 or 6.4.5, and notifies AZZIR that
              it has agreed to provide such refund, AZZIR will process any
              refund due to such Customer within a reasonable period and, in any
              case, within 30 days of the day the refund is notified by the
              Promoter.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.4.7 If an Event or Offer is cancelled, the Promoter of the Event
              or Offer will inform the Customer and AZZIR prior to such
              cancellation and hereby authorises AZZIR to refund to the User the
              Ticket price or the Voucher price minus the booking fee, which
              shall not be refunded in any circumstances.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                6.5 Direct pay Ticket and Voucher sales
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.1 Tickets and Vouchers sold through AZZIR’s Direct Pay method
              are sold for Events and Offers advertised by Promoters, where
              transactions are processed through the Promoter’s merchant
              account. Transactions of this nature adhere to the terms of clause
              6.5.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.2 AZZIR will usually invoice the Promoter for all sums due to
              it relating to an Event within 5 working days of the end of the
              month of the Event and the Promoter shall pay such invoice within
              5 working days of the end of the month of the Event.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.3 The Promoter of the Event is responsible for setting its own
              terms and conditions, including cancellation and refund policy.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.4 It is the responsibility of the Customer to check the
              Promoter’s terms and conditions with the Promoter before the
              purchase of any Tickets/Vouchers.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.5 If the Customer wishes to obtain a refund for a
              Ticket/Voucher from the Promoter, AZZIR will forward on any such
              requests to the Promoter. AZZIR shall not be liable to the
              Customer for any refunds.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.6 If a Customer requests a refund from a Promoter, the
              Promoter shall process such request in good faith and in
              accordance with its terms and conditions that it had in place at
              the time the Customer purchased the Ticket(s)/Voucher(s) in
              question.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              6.5.7 AZZIR is in no way responsible for Tickets/Vouchers sold
              through the Direct Pay method and has no authority, and shall not
              be liable, to issue refunds to a Customer without the Promoter’s
              consent.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                7. STATUS OF AZZIR
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              7.1 AZZIR is a ticketing agency and does not host, promote or
              produce the Events or Offers.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              7.2 AZZIR does not set prices for the Events or Offers and charges
              a booking fee, which is included in the overall price paid by the
              User.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              7.3 AZZIR does not accept any other liability for any Ticket or
              Voucher purchases made via the Website, the App and/or the
              Service, save as set out in these Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              7.4 There may be other terms and conditions applicable to any
              Event or Offer and Users should check these before committing to a
              purchase, in particular for terms such as age requirements and
              alcohol policies.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                8. INTELLECTUAL PROPERTY
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.1 The User acknowledges that all Intellectual Property Rights
              subsisting in the Website, the App and the Service, including in
              relation to the design, text, graphics, music, photographs, sound,
              video and any other material as well as the selection or
              arrangement thereof, are owned by AZZIR or are owned by third
              parties and used by AZZIR under licence.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.2 The User may print off one copy, and may download extracts, of
              any page(s) from the Website, the App or the Service for their
              personal use.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.3 The User must not modify the paper or digital copies of any
              materials they have printed off or downloaded in any way, and must
              not use any illustrations, photographs, video or audio sequences
              or any graphics separately from any accompanying text.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.4 AZZIR’s status (and that of any identified contributors) as
              the authors of Content on the Website, the App and the Service
              must always be acknowledged.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.5 The User must not use any part of the Content for commercial
              purposes without obtaining a licence to do so from AZZIR or its
              licensors.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              8.6 If the User prints off, copies or downloads any part of the
              Website, the App and the Service in breach of these Terms, the
              User’s right to use the Website, the App and the Service will
              cease immediately and the User must, at AZZIR’s option, return or
              destroy any copies of the materials the User has made.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                9. USER WARRANTIES AND REPRESENTATIONS
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              9.1 The User represents and warrants to AZZIR that their use of
              the Service shall:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.1.1 not be in breach of any contractual, statutory (including
              but not limited to infringement of Intellectual Property Rights,
              data protection, defamation, theft, fraud, drug-trafficking,
              money-laundering and terrorism statutes) or common law rights of
              any third party; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              -9.1.2 not be threatening, fraudulent, abusive, harassing,
              defamatory, invasive of privacy or publicity rights, vulgar,
              obscene, profane, indecent, or otherwise objectionable or
              inappropriate as determined by AZZIR at its sole discretion.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              9.2 The User represents and warrants that all the information that
              they supply to AZZIR shall be accurate, complete and true in all
              respects and the User agrees that they shall notify AZZIR
              immediately of any changes to such information or if such
              information becomes out of date.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              9.3 The User shall comply with AZZIR’s reasonable instructions in
              relation to their use of the Website, the App and the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              9.4 The User shall not:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.4.1 obtain or attempt to obtain, the Service by re-arranging,
              tampering with, or making connection with any facilities of AZZIR,
              or by any trick, scheme, false representation or by or through any
              other fraudulent means or devices whatsoever in whole or in part;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.4.2 attempt to, or actually, obtain, access, alter or destroy
              any one or more of the software, data files, programs, procedures
              or information of AZZIR or of another user of the Service;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.4.3 assist another to perform the acts prohibited in clauses
              9.4.1 and 9.4.2 above;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.4.4 use the Service in such a manner as to interfere
              unreasonably with the use of the Service by any other User or
              authorised person; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 9.4.5 allow any other person or entity to use or access the
              Service unless they are a duly authorised officer, agent or other
              representative of the User.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                10. BUGS, VIRUSES AND PDPs
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.1 The User represents and warrants to AZZIR that their use of
              the Service shall not cause any PDPs to be transmitted to the
              Server.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.2 The User shall inform AZZIR immediately if they become aware
              of any PDPs, bugs or errors on the Website, the App or the
              Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.3 The User acknowledges that, despite AZZIR taking reasonable
              precautions, it is still possible that PDPs may be transmitted
              from the Server or a server belonging to any third party to the
              User’s Equipment. The User therefore accepts that is shall have
              full responsibility for protecting the User’s Equipment from PDPs
              and AZZIR shall have no responsibility for ensuring that content
              downloaded from the Website is free of PDPs.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.4 AZZIR has used its reasonable endeavours to ensure that the
              Website is secure. However, AZZIR does not warrant or represent
              that either this is the case or that the internet is secure.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.5 AZZIR will not be liable for any loss or damage caused by a
              PDP or other technologically harmful material that may infect the
              User’s Equipment, computer programs, data or other proprietary
              material due to the User’s use of the Website, the App or the
              Service or due to the User downloading any Content or accessing
              any website linked to the Website, the App or the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              10.6 The User acknowledges that any data transmitted to AZZIR or
              the Server electronically via the internet, an intranet or another
              private network including the Website may be intercepted by third
              parties and unlawfully exploited. The User accordingly accepts
              that AZZIR has no responsibility in respect of the acts of such
              third parties.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                11. USE OF DATA AND DATA PROTECTION
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.1 By providing AZZIR with the data set out in this clause 11
              and by Accepting these Terms, the User acknowledges that their
              data will be used in accordance with these terms and conditions
              and the Privacy Policy.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.2 All parties to these terms agree to comply with all
              applicable requirements of the Data Protection Laws. This clause
              11.2 is in addition to, and does not relieve, remove or replace, a
              party’s obligations under the Data Protection Laws.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                11.3 Information collected by AZZIR
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.3.1 When the User registers with AZZIR to use the Service, the
              User provides Personal Data and information by means of
              registration screens on the Website or any App that uses the
              Service and, as the User uses the Service, AZZIR shall collect
              further information from the User, which may include Personal
              Data.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.3.2 AZZIR shall be the Data Controller in relation to any
              Personal Data collected under clause 11.3.1 and its use of
              Personal Data is set out in the Privacy Policy
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                11.4 Information Imported by a Promoter
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.4.1 If a Promoter imports its own database or other contact
              information it has collected into the Server, that database shall
              remain owned by that Promoter. The Promoter shall be the Data
              Controller in relation to any Personal Data collected pursuant to
              this clause 11.4.1. AZZIR will be a Data Processor of this data
              and shall comply with its obligations as a Data Processor as set
              out in clauses 11.6.5 to 11.6.12 of these terms and the Privacy
              Policy
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.4.2 Further to clause 11.4.1, the Promoter warrants that, where
              it is a Data Controller, it shall provide each Data Subject with
              the required information as set out in Article 14 of the GDPR,
              including but not limited to the identity and contact details of
              the Promoter, the purposes for processing their information and
              the categories of personal data with which the Promoter is
              concerned.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.4.3 The Promoter warrants that it has all consents required to
              allow it to import its database referred to in clause 11.4.1 into
              the Server and to allow AZZIR to process such Personal Data in
              accordance with these Terms and the terms of the Privacy Policy.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.4.4 Personal Data imported or collected into a brand following
              owned by the Promoter may be exported out of the Service by the
              Promoter at any time.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                11.5 Users who follow Promoters
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.5.1 If a Customer, or other User, creates an account on the
              AZZIR platform and follows a Promoter pursuant to clause 5.5.5
              (including a Data Subject who was initially introduced to the
              Service through the importing of a database pursuant to clause
              11.4.1),that User’s data shall become part of AZZIR’s database.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.5.2 Where the events in clause 11.5.1 occur, both AZZIR and the
              Promoter shall be referred to as a Data Controller in relation to
              any Personal Data provided by a User. Further information how
              AZZIR will use such data can be found in the Privacy Policy.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.5.3 AZZIR and each User hereby grants permission to the
              Promoter to, at any time for the duration of these Terms:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.5.3.1 use any data relating to a User who follows that
              Promoter, and has agreed to receive marketing information, for the
              purposes of promoting and marketing that Promoter’s Events or
              Offers;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.5.3.2 use any data relating to a User who has purchased a
              ticket to one of that Promoter’s Events or Offers for the purposes
              of promoting and marketing similar Events and Offers promoted by
              that Promoter; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.5.3.3 export from the Service all data relating to Users who
              follow that Promoter.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.5.4 The Promoter hereby undertakes fully and effectively to
              indemnify and keep indemnified at all times AZZIR against all
              actions, proceedings, costs, claims, demands, liabilities and
              expenses whatsoever (including legal and other fees and
              disbursements) sustained, suffered, incurred or paid by AZZIR
              directly or indirectly in respect of any breach by the Promoter of
              this clause 11.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                11.6 General use of Data
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.1 All Users shall:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.1.1 only use Personal Data in accordance with these Terms
              and the privacy policy;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.1.2 comply with all reasonable instructions of AZZIR in
              relation to any data;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.1.3 process all data fairly and lawfully; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.1.4 put in place appropriate security measures to protect
              data from unauthorised or unlawful processing and accidental loss
              or destruction.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.2 As set out in the Privacy Policy, a User is entitled to
              withdraw their consent to any processing of their Personal Data at
              any time and shall do so by contacting AZZIR advising them of such
              withdrawal.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.3 If a User withdraws their consent to processing in
              accordance with clause 11.6.2 above:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.3.1 AZZIR shall cease to process such applicable Personal
              Data and shall inform any other Users who currently hold such
              Information; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.3.2 any User who holds this Personal Data warrants that it
              will cease to process such personal data.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.4 All Users hereby undertake fully and effectively to
              indemnify and keep indemnified at all times AZZIR against all
              actions, proceedings, costs, claims, demands, liabilities and
              expenses whatsoever (including legal and other fees and
              disbursements) sustained, suffered, incurred or paid by AZZIR
              directly or indirectly in respect of a breach by that User of this
              clause 11.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.5 Where any individual to whom these terms apply is a Data
              Processor, they agree that they will only process Personal Data in
              accordance with the written instructions of the Data Controller of
              that Personal Data unless required to do so by law.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.6 Where any individual to whom these terms apply is a Data
              Controller, it will ensure that it has all necessary appropriate
              consents and notices in place to enable lawful transfer of
              Personal Data to any Data Processor.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.7 Where any individual to whom these terms apply is a Data
              Processor and appoints a Sub-Processor, the Data Processor must
              impose similar contract terms on the Sub-Processor as are required
              by the Data Protection Laws, especially but not exclusively, those
              contract terms required under Article 28.3 of the GDPR.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.8 A Data Processor will not transfer the Personal Data
              outside of the European Economic Area (EEA) unless:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.8.1 the Data Processor has obtained the prior written
              consent of the Data Controller;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.8.2 the Data Processor has provided Appropriate Safeguards
              in relation to the transfer, and can demonstrate this to the
              reasonable satisfaction of the Data Controller;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.8.3 the Data Subjects whose Personal Data will be
              transferred have enforceable rights and effective legal remedies;
              and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.8.4 the Data Processor can provide an adequate level of
              protection to any Personal Data that is transferred.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.9 The Data Processor shall put in place appropriate technical
              and organisational measures to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.9.1 protect against unauthorised or unlawful processing of
              Personal Data and against accidental loss or destruction of, or
              damage to, the Personal Data; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.9.2 allow the Data Controller to meet its obligations to
              Data Subjects, including but not limited to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - - (a) rectification or erasure of Personal Data;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - - (b) Restriction Of Processing of Personal Data;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - - (c) Data Portability; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - - (d) prompt response to Subject Access Requests.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.10 The Data Processor will obtain a commitment of
              confidentiality from anyone it allows to process the Personal
              Data, including but not limited to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.10.1 the Data Processor’s employees, agents, officers and
              affiliates;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.10.2 agency or temporary workers; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.10.3 Sub-contractors or Sub-Processors.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.11 The Data Processor will assist the Data Controller, so far
              as is possible and taking into account the nature of the
              processing under these terms and the information available to the
              Data Processor, in meeting the Data Controller’s obligations under
              the Data Protection Laws, including but not limited to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.11.1 the obligation to keep Personal Data secure;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.11.2 the obligation to notify Personal Data Breaches to the
              Supervisory Authority;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.11.3 the obligation to advise Data Subjects where there has
              been a Personal Data breach;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.11.4 the obligation to carry out data protection impact
              assessments; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.11.5 the obligation to consult with the supervisory
              authority where a data protection impact assessments indicates an
              unmitigated high risk to the processing activities under these
              terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              11.6.12 Both parties shall:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.12.1 retain all information required to demonstrate that
              the Data Processors and the Data Controllers have met their
              obligations under the Data Protection Laws;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.12.2 inform a Data Controller immediately if the Data
              Processor believes or suspects that it has been given an
              instruction that does not comply with the Data Protection Laws;
              and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 11.6.12.3 notify a Data Controller immediately if a Data
              Processor becomes aware of or reasonably suspects a Personal Data
              breach.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                12. EXCLUSION OF WARRANTIES / LIMITATION OF LIABILITY
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.1 Where the User accesses the Service by means of the internet,
              AZZIR will use its reasonable endeavours to ensure that the
              Service is accessible at all times via the internet but AZZIR does
              not warrant or represent that it can do so since neither AZZIR nor
              any other party has any control over the internet, which is a
              global decentralised network of computer systems.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.2 The Service is provided “as is” without any warranty of any
              kind either express or implied including but not limited to the
              implied warranties of satisfactory quality, merchantability,
              fitness for a particular purpose, title and non-infringement of
              Intellectual Property Rights.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.3 Neither AZZIR nor any of its directors, employees or other
              representatives will be liable for loss or damage arising out of
              or in connection with the use of the Service. This is a
              comprehensive limitation of liability that applies to damages of
              any kind, whether arising from negligence, breach of contract,
              statutory duty or otherwise, including (without limitation):
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.1 compensatory damages;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.2 direct losses;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.3 indirect or consequential loss;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.4 loss of data;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.5 loss of income or profit; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.3.6 loss of or damage to property and claims of third
              parties.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.4 The total liability of AZZIR to the User, whether in
              contract, tort (including negligence) or otherwise in connection
              with these Terms, the Website, the App or the Service, shall in no
              circumstances exceed a sum equal to:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.4.1 the amount paid or received through the Service by the
              User in the immediately preceding twelve month period; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.4.2 if the User has not been a User for a full twelve months,
              a pro rata amount equivalent to what would have been paid over a
              full twelve months if the User continued to pay and receive the
              Service at the same average rate as it had done previously.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.5 AZZIR is not responsible in contract or in tort for the
              unauthorised access to, or alteration, theft or destruction of
              emails, files, programs, or information of the User by any person
              through accident or by fraudulent means or devices, even if such
              access occurs as a result of AZZIR’s own negligence.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.6 AZZIR does not guarantee that the Website, the App, the
              Service and/or any Content, will always be available or be
              uninterrupted. AZZIR may suspend or withdraw or restrict the
              availability of all or any part of the Website, the App, the
              Service and/or any Content for business and operational reasons.
              AZZIR will use reasonable endeavours to give reasonable notice of
              any suspension or withdrawal.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.7 AZZIR accepts no responsibility for misused User accounts.
              AZZIR is not liable for losses incurred due to the misuse of an
              account by a User or any other party, whether such loss is
              personal to that User or to any other User. This includes but is
              not limited to: incorrect withdrawal of funds, provision of
              incorrect Event or Offer information or pricing and other general
              misuse of the account.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              12.8 The exclusions in this clause 12 shall apply to the fullest
              extent permissible at law, but AZZIR does not exclude liability
              for:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.8.1 death or personal injury caused by its negligence;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.8.2 fraud or fraudulent misrepresentation; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 12.8.3 any other liability which may not be excluded by law
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                13. INDEMNITIES
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              The User undertakes fully and effectively to indemnify and keep
              indemnified at all times AZZIR against all actions, proceedings,
              costs, claims, demands, liabilities and expenses whatsoever
              (including legal and other fees and disbursements) sustained,
              suffered, incurred or paid by AZZIR directly or indirectly in
              respect of:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              13.1 access to and/or use of the Website, the App or the Service
              by the User;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              13.2 any Content, information, data or material produced,
              transmitted or downloaded by the User;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              13.3 the Customer’s breach of any third party’s terms and
              conditions, including those of a Promoter, howsoever arising; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              13.4 any breach by the User of any of these Terms or of any
              applicable law, code or regulation.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                14. LINKS TO OTHER SITES
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              Certain links, including hypertext links, in the Website will take
              the User outside the Website. Links are provided for the User’s
              convenience and inclusion of any link does not imply endorsement
              or approval by AZZIR of the linked site, its operator or its
              content. AZZIR is not responsible for the content of any website
              outside the Website.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                15. FORCE MAJEURE
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              15.1 AZZIR shall not be responsible for any delay in, or failure
              of, the Service or the internet due to any occurrence commonly
              known as force majeure, including war, riots, embargoes,
              terrorism, strikes, or other concerted acts of workmen (whether of
              AZZIR or others) casualties or accidents, or any other causes,
              circumstances, or contingencies beyond AZZIR’s control, which
              prevent or hinder the performance of AZZIR of any of its
              obligations hereunder.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              15.2 In such circumstances, AZZIR shall be entitled to a
              reasonable extension of the time for the reinstatement of such
              Service. If the period of delay or non-performance continues for a
              period of eight (8) weeks or more, the User or AZZIR may terminate
              these Terms by giving not less than fourteen (14) days’ written
              notice to the other party.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                16. TERMINATION
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              16.1 Either party may terminate these Terms immediately by
              notifying the other that these Terms are terminated.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              16.2 On termination of these Terms by either party pursuant to
              clause 16.1:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 16.2.1 all rights granted to the User under these Terms shall
              cease;
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 16.2.2 the User shall cease all activities authorised by these
              Terms; and
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 16.2.3 the User shall immediately destroy or return to AZZIR (at
              AZZIR’s option) all copies of any Content or other materials which
              they hold in relation to the Website, the App or the Service.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              16.3 Any provision of these Terms which expressly or by
              implication is intended to come into or continue in force on or
              after termination of these Terms shall remain in full force and
              effect.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                17. WAIVER
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              Failure or neglect by AZZIR to enforce at any time any of the
              provisions hereof shall not be construed nor shall be deemed to be
              a waiver of AZZIR’s rights hereunder nor in any way affect the
              validity of the whole or any part of these Terms nor prejudice
              AZZIR’s rights to take subsequent action.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                18. ASSIGNMENT
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              18.1 Neither these Terms nor the benefit of the Service may be
              assigned or transferred by the User whether voluntarily or
              involuntarily or by operation of law, in whole or in part, to any
              party without the prior written consent of AZZIR, and AZZIR
              reserves the right to charge for any time or costs incurred by its
              staff in so doing. No such assignment by the User howsoever
              occurring shall relieve the User of their obligations hereunder.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              18.2 AZZIR is fully entitled to assign or transfer these Terms or
              the Service at any time.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                19. NOTICES
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              19.1 Any notice required or permitted under these Terms or
              required by statute, law or regulation shall (unless otherwise
              provided) be in writing and shall be delivered in person, or sent
              by registered mail or air mail as appropriate, properly posted and
              fully prepaid in an envelope properly addressed to AZZIR as
              follows:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              7th Floor, Esperanca, Shahid Bhagat Singh Road <br /> Near
              Electric House, Colaba, <br /> Mumbai Maharashtra 400001
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              or to such other address as may from time to time be designated by
              notice set out on the Website or otherwise notified to the User.
              AZZIR may at its sole discretion notify Users of any matter by
              displaying a message on the Website.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              19.2 Any such notice shall be in the English language and shall be
              considered to be received within seven days after it was sent in
              the manner hereinbefore provided.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                20. INVALIDITY
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              20.1 If at any time any provision of these Terms is or becomes
              illegal, invalid or unenforceable in any respect under the law of
              any jurisdiction, that shall not affect or impair:
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 20.1.1 the legality, validity or enforceability in that
              jurisdiction of any other provision of these Terms; or
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              - 20.1.2 the legality, validity or enforceability under the law of
              any other jurisdiction of that or any other provision of these
              Terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                21. AGREEMENT
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              These Terms supersede any arrangements, understanding, promises or
              agreements made or existing between the parties hereto prior to
              these Terms in respect of the Service and constitutes the entire
              understanding between the parties hereto regarding the same.
              Except as otherwise provided herein, no addition, amendment to or
              modification of these Terms shall be effective unless it is in
              writing and signed by and on behalf of both parties.
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <strong>
              <span
                style={{
                  fontSize: 24,
                  fontFamily: '"Segoe UI",sans-serif',
                  color: "black",
                }}
              >
                22. LAW AND JURISDICTION
              </span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "normal",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
              background: "transparent",
            }}
          >
            <span style={{ fontSize: 16, fontFamily: '"Segoe UI",sans-serif' }}>
              These Terms shall be governed and construed in accordance with
              Indian law and parties hereby submit themselves to the exclusive
              jurisdiction of the Indian courts in respect of any claim
              (including non-contractual disputes or claims).
            </span>
          </p>
          <p
            style={{
              marginTop: "0cm",
              marginRight: "0cm",
              marginBottom: "8.0pt",
              marginLeft: "0cm",
              lineHeight: "107%",
              fontSize: 15,
              fontFamily: '"Calibri",sans-serif',
            }}
          >
            &nbsp;
          </p>
        </div>
        <a href="#" className="back-to-top">
          <i className="fa fa-chevron-up" />
        </a>
      </div>
    </Layout>
  );
};

export default TermsAndConditions;
